import { axiosGet } from '@/api/handlers';
import { useQuery } from '@/api/hooks';
import {
  ConsecutiveFiscalYearsModel,
  ConsecutiveRequestAmountsModel,
} from '../../../../_models/consecutive';
import { queryKeyMap } from '../../../../_utils/query-keys';
import {
  ConsecutiveBudgetsModel,
  ConsecutiveExecutionsModel,
} from '../../../_models/consecutive';

export const useConsecutiveFiscalYears = ({
  id,
  enabled = true,
}: {
  id: string;
  enabled?: boolean;
}) => {
  return useQuery({
    queryKey: queryKeyMap.consecutiveFiscalYears(id),
    queryFn: async () => {
      const res = await axiosGet(
        `/api/projects/${id}/consecutive/fiscal-years/`,
      );
      return ConsecutiveFiscalYearsModel.parse(res);
    },
    enabled: !!id && enabled,
  });
};

export const useConsecutiveRequestAmounts = ({
  id,
  enabled = true,
}: { id: string; enabled?: boolean }) => {
  return useQuery({
    queryKey: queryKeyMap.consecutiveRequestAmounts(id),
    queryFn: async () => {
      const res = await axiosGet(
        `/api/projects/${id}/consecutive/request-amounts/`,
      );
      return ConsecutiveRequestAmountsModel.parse(res);
    },
    enabled: !!id && enabled,
  });
};

export const useConsecutiveBudgets = ({
  id,
  enabled = true,
}: { id: string; enabled?: boolean }) => {
  return useQuery({
    queryKey: queryKeyMap.consecutiveBudgets(id),
    queryFn: async () => {
      const res = await axiosGet(`/api/projects/${id}/consecutive/budgets/`);
      return ConsecutiveBudgetsModel.parse(res);
    },
    enabled: !!id && enabled,
  });
};

export const useConsecutiveExecutions = ({
  id,
  enabled = true,
}: { id: string; enabled?: boolean }) => {
  return useQuery({
    queryKey: queryKeyMap.consecutiveExecutions(id),
    queryFn: async () => {
      const res = await axiosGet(`/api/projects/${id}/consecutive/executions/`);
      return ConsecutiveExecutionsModel.parse(res);
    },
    enabled: !!id && enabled,
  });
};
